var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"introduction"},[_c('p',[_vm._v("Hi! My name is Susanna. Here you can find my CV and BCS web application development training certificate. ")])])
}]

export { render, staticRenderFns }